export const uk = {
    'all-conditions-are-negative': 'В условии нельзя установить "Не выполнено ни одного" для всех наборов правил.',
    'app-metrika-segment': 'сегмент AppMetrica',
    composition: 'комбинированный',
    'condition-rule-id-required': 'Не указана цель',
    'condition-rule-period-required': 'Не указано количество дней',
    'condition-rule-period-value-interval': 'Укажите корректное количество дней: от {minValue} до {maxValue}',
    'condition-rule-period-value-max-value': 'Количество дней не должно превышать {value}',
    'condition-rule-period-value-negative-value': 'Количество дней не может быть отрицательным',
    crm: 'данные CRM',
    'description-max-length': 'Примечание не должно превышать {value} символов',
    'description-must-contain-only-symbols':
        'В примечании допускается использование букв латинского, турецкого, русского, украинского, казахского алфавитов, цифр и знаков пунктуации',
    email: 'эл. почта',
    'geo-condition': 'гео условие',
    'geo-now': 'гео сейчас',
    'geo-regular': 'гео регулярные',
    'goals-or-segment-error': 'В наборе правил {numberOfGroups} необходимо выбрать цели/сегменты',
    'inconsistent-name': 'Условие с таким названием уже существует',
    'inconsistent-rules-groups': 'Условие с такими наборами правил уже существует',
    'incorrect-goal-id': 'Указана некорректная цель',
    'look-alike': 'похожий сегмент',
    mac: 'MAC-адреса',
    median: 'медиана',
    'metrika-segment': 'сегмент Метрики',
    'mobiles-ids': 'ID мобильных',
    'name-max-length': 'Название условия не должно превышать {value} символов',
    'name-must-contain-only-symbols':
        'В названии условия допускается использование букв латинского, турецкого, русского, украинского, казахского алфавитов, цифр и знаков пунктуации',
    'name-required': 'Не указано название условия',
    phones: 'телефоны',
    pixel: 'пиксель',
    'required-goal-id': 'Не указана цель',
    'required-goal-period': 'Для правил с сегментами и целями метрики необходимо указать период',
    'rules-groups-cannot-be-null': 'В условии должно быть задан хотя бы один набор правил',
    'unknown-error': 'Не удалось сохранить условие ретаргетинга',
    'yandex-data': 'данные Яндекс'
};
